export function isSlotFree(slot: any, formDate: any, bookings: any[]): boolean {
    if( 
        bookings.find( ( booking:any ) => {
            return booking.start < new Date( `${ formDate } ${ slot.from }` ).getTime() && new Date( `${ formDate } ${ slot.from }` ).getTime() < booking.end 
        })
    ) return false;

    if( 
        bookings.find( ( booking:any ) => {
            return booking.start < new Date( `${ formDate } ${ slot.to }` ).getTime() && new Date( `${ formDate } ${ slot.to }` ).getTime() < booking.end 
        })
    ) return false;

    if( 
        bookings.find( ( booking:any ) => {
            return booking.start == new Date( `${ formDate } ${ slot.from }` ).getTime() && new Date( `${ formDate } ${ slot.to }` ).getTime() == booking.end 
        })
    ) return false;

    //IF Slots are between so there is a slot from 10-12oo and you want to book 8-14oo this should not be possible
    if( 
        bookings.find( ( booking:any ) => {
            return booking.start >= new Date( `${ formDate } ${ slot.from }` ).getTime() && new Date( `${ formDate } ${ slot.to }` ).getTime() >= booking.end 
        })
    ) return false;

    return true;
}
